<template>
  <div>
    <a-form-model ref="ruleForm" :layout="layout" :model="form" :rules="rules">
      <!-- <a-form-model-item label="Resources" prop="resource">
        <a-radio-group v-model="form.resource">
          <a-radio value="1"> Sponsor </a-radio>
          <a-radio value="2"> Venue </a-radio>
        </a-radio-group>
      </a-form-model-item> -->
      <a-form-model-item label="试题内容：" prop="topic">
        <a-input v-model="form.topic" type="textarea" />
      </a-form-model-item>
      <a-form-model-item label="关联项：" prop="relevance">
        <a-select mode="multiple" v-model="form.relevance" placeholder="请选择关联项" :options="relevanceOptions" />
      </a-form-model-item>
      <!-- <a-form-model-item label="判断类型：" prop="judgmentType">
        <a-select
          v-model="form.judgmentType"
          placeholder="请选择判断类型"
          :options="judgmentTypeOptions"
          @change="changeJudgmentType"
        />
      </a-form-model-item>
      <a-form-model-item
        class="add-input"
        v-for="(item, index) in form.topicOptions"
        :key="item.key"
        :label="index === 0 ? '题目选项：' : ''"
        :prop="'topicOptions.' + index + '.value'"
        :rules="{
          required: true,
          message: '题目选项不能为空',
          trigger: 'blur',
        }"
      >
        <a-input v-model="item.value" disabled :addon-before="item.key" placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item>
        <a-button type="primary" @click="onSubmit">保存</a-button>
        <a-button style="margin-left: 10px" @click="resetForm">重置</a-button>
      </a-form-model-item> -->
    </a-form-model>
  </div>
</template>

<script>
export default {
  name: 'Judgment',
  data() {
    return {
      layout: 'vertical',
      form: {
        topic: '',
        relevance: [],
        judgmentType: '0',
        topicOptions: [
          {
            key: 'A',
            value: '是',
          },
          {
            key: 'B',
            value: '否',
          },
        ],
      },
      relevanceOptions: [
        { label: '学习好', value: '学习好' },
        { label: '情绪稳定', value: '情绪稳定' },
        { label: '家庭条件', value: '家庭条件' },
        { label: '工作压力', value: '工作压力' },
        { label: '身体健康', value: '身体健康' },
        { label: '兴趣爱好', value: '兴趣爱好' },
        { label: '其他', value: '其他' },
      ],
      judgmentTypeOptions: [
        { label: '是-否', value: '0' },
        { label: '对-错', value: '1' },
        { label: '正确-错误', value: '2' },
      ],
      rules: {
        topic: [{ required: true, message: '请输入试题内容', trigger: 'blur' }],
        relevance: [{ required: true, message: '请选择关联项', trigger: 'blur' }],
        judgmentType: [{ required: true, message: '请选择判断类型', trigger: 'blur' }],
      },
    };
  },
  methods: {
    changeJudgmentType(value) {
      console.log('选择项：', value);
      const currTypeOptions = [
        ['是', '否'],
        ['对', '错'],
        ['正确', '错误'],
      ][value].map((item, index) => ({
        key: String.fromCharCode(65 + index),
        value: item,
      }));
      console.log('当前类型选项：', currTypeOptions);
      this.$set(this.form, 'topicOptions', currTypeOptions);
    },
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          console.log('提交信息：', this.form);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
  },
};
</script>
<style scoped lang="less">
.add-input {
  /deep/ .ant-form-item-children {
    display: flex;
    align-items: center;
    .ant-input {
      flex: 1;
    }
    .anticon-delete {
      width: 28px;
    }
  }
}
</style>
